import { create } from "zustand";

type AuthState = {
  token: string | null
  user: any
  isAuthLoading: boolean

  setToken: (token: string | null) => void
  setUser: (user: any) => void
  setAuthLoading: (loading: boolean) => void

  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  user: null,
  isAuthLoading: true,

  setToken: (token) => set({ token }),
  setUser: (user) => set({ user }),
  setAuthLoading: (loading) => set({ isAuthLoading: loading }),

  logout: () => {
    localStorage.removeItem("auth_token")
    set({ token: null, user: null })
  },
}))